export interface MetadataField {
  key: string;
  label: string;
  type: "text" | "number" | "date" | "select";
  required?: boolean;
  section?: string;
  options?: string[];                          
}

export const ComponentMetadata: Record<string, MetadataField[]> = {
  
  Engine: [
    {
      key: "engineCurrentThrust",
      label: "Current Operating Thrust",
      type: "text",
      section: "Engine Details",
    },
    {
      key: "engineDateLastShopVisit",
      label: "Date of Last Shop Visit",
      type: "date",
      section: "Engine Status",
    },
    {
      key: "engineLlpStatus",
      label: "LLP Status",
      type: "text",
      section: "Engine Status",
    },
    {
      key: "engineTsnLastShopVisit",
      label: "TSN Last Shop Visit",
      type: "number",
      section: "Engine Status",
    },
    {
      key: "engineCsnLastShopVisit",
      label: "CSN Last Shop Visit",
      type: "number",
      section: "Engine Status",
    },
    {
      key: "engineAsOfDate",
      label: "As Of Date",
      type: "date",
      section: "Engine Status",
    },
  ],

  APU: [
    {
      key: "apuPartNumber",
      label: "Part Number (P/N)",
      type: "text",
      section: "APU Status",
    },
    {
      key: "apuTsn",
      label: "Time Since New (TSN)",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuCsn",
      label: "Cycle Since New (CSN)",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuAsOfDate",
      label: "As Of Date",
      type: "date",
      section: "APU Status",
    },
    {
      key: "apuCycles",
      label: "Cycles",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuLastHsiOverhaulDate",
      label: "Completion Date of Last HSI/Overhaul",
      type: "date",
      section: "APU Status",
    },
    {
      key: "apuTsnLastHsiOverhaul",
      label: "Time Since New (TSN) Last HSI/Overhaul",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuCsnLastHsiOverhaul",
      label: "Cycle Since New (CSN) Last HSI/Overhaul",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuLlpStatus",
      label: "Limited Life Part (LLP) Status",
      type: "text",
      section: "APU Status",
    },
    {
      key: "apuCyclesRemainingToFirstLlp",
      label: "Cycles Remaining to 1st LLP Limiter",
      type: "number",
      section: "APU Status",
    },
    {
      key: "apuAnnualUtilization",
      label: "APU Annual Utilization (FH/FC)",
      type: "text",
      section: "APU Status",
    },
  ],

  LandingGear: [
    {
      key: "lgHasSubAssembly",
      label: "Landing gear has sub-assembly",
      type: "select",
      options: ["Yes", "No"],
      section: "Sub-Assembly",
    },
    {
      key: "lgTsn",
      label: "Time Since New (TSN)",
      type: "number",
      section: "Utilization & Overhaul",
    },
    {
      key: "lgCsn",
      label: "Cycle Since New (CSN)",
      type: "number",
      section: "Utilization & Overhaul",
    },
    {
      key: "lgAsOfDate",
      label: "As Of Date",
      type: "date",
      section: "Utilization & Overhaul",
    },
    {
      key: "lgLastOverhaulDate",
      label: "Date of Last Overhaul",
      type: "date",
      section: "Utilization & Overhaul",
    },
    {
      key: "lgBackToBirth",
      label: "Back-to-Birth Traceability (Availability)",
      type: "select",
      options: ["Yes", "No"],
      section: "Utilization & Overhaul",
    },
    {
      key: "lgTsnAtOverhaul",
      label: "TSN at Overhaul",
      type: "number",
      section: "Utilization & Overhaul",
    },
    {
      key: "lgCsnAtOverhaul",
      label: "CSN at Overhaul",
      type: "number",
      section: "Utilization & Overhaul",
    },
  ],
};
